import React from 'react';

export const Input = ({
    placeholder,
    name,
    type,
    requiredir,
    id,
    autoComplete,
    className,
    onChange,
    value,
    onKeyUp,
    pattern,
    checked,
    disabled,
    step,
    defaultValue,


}) => {
    return (
        <div className="w-full">

            <input
                className={`block ${className} p-3 px-2.5 pb-2.5 border w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
                type={type}
                placeholder={placeholder}
                requiredir={`${requiredir}`}
                id={id}
                value={value}
                autoComplete={autoComplete}
                name={name}
                onChange={onChange}
                onKeyUp={onKeyUp}
                pattern={pattern}
                checked={checked}
                disabled={disabled}
                step={step}
                defaultValue={defaultValue}

            />


            <label
                htmlFor={id}
                className="absolute  pr-3 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white   peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
            >
                {placeholder}
            </label>
        </div>



    );
};
